import React from 'react';
import { Platform } from 'react-native';
import { createStackNavigator } from '@react-navigation/stack';
import { useTranslation } from 'react-i18next';
import { useToken } from '@gluestack-ui/themed';

import Login from '../../auth/Login';
import ForgotPassword from '../../auth/ForgotPassword';
import ResetPassword from '../../auth/ResetPassword';

const Stack = createStackNavigator();

const AuthNavigator = () => {
  const { t } = useTranslation();
  const backgroundColor = useToken('colors', 'backgroundLight100');

  return (
    <Stack.Navigator
      id="authNavigation"
      initialRouteName="Login"
      screenOptions={{
        headerShown: false,
        cardOverlayEnabled: false,
        animationEnabled: Platform.OS !== 'web',
        cardStyle: { backgroundColor },
        unmountOnBlur: true,
      }}
    >
      <Stack.Screen
        name="Login"
        component={Login}
        options={{
          headerShown: false,
          title: t('login.title'),
        }}
      />

      <Stack.Screen
        name="ForgotPassword"
        component={ForgotPassword}
        options={{
          headerShown: false,
          title: t('forgot-password.title'),
        }}
      />

      <Stack.Screen
        name="ResetPassword"
        component={ResetPassword}
        options={{
          headerShown: false,
          title: t('reset-password.title'),
        }}
        initialParams={{ token: null }}
      />
    </Stack.Navigator>
  );
};

export default AuthNavigator;
